import Axios from "axios";
import is_localhost from "./class_is_localhost";
import class_check_language from "./class_check_language";
//import { Store } from "vuex";
//import groupBy from "class_group_by";
export default class get_json_product {
  // self sarebbe il this di groupvue
  // that sarebbe sempre il this di groupvue
  // ci sono due this 
  get_json_product_dev(prodk, that, self) {
    this.GET_LIST_PROMISE(prodk, that, self)
      .then((response) => {
        response.data = response;
        that.SORGENTE = response.data.sorgenti_estese.model.SORGENTE;
        that.SORGENTI = response.data.sorgenti_estese.elettrificazioni;
        self.data = response.data;
        self.data.details_old = that.data.details;
        that.$store.commit('json_taken', response.prezzi);
        that.$store.commit('json_taken_details', response.details);
        try {
          that.$store.commit('json_taken_codici', response.codici);
        } catch (error) {
          console.info(error);
        }
        that.$store.commit('json_taken_finiturastruttura', response.finiturastruttura);
        that.$store.commit('json_taken_certificazioni', response.certificazioni);
        that.$store.commit('click_on_montatura_bis');
        try {
          that.changeUrl();
        } catch (error) {
           this.err = error;
        }
      })

  }

  get_json_note_dev(prodk, that, self) {
    this.GET_NOTE_PROMISE(prodk, that, self)
      .then((response) => {
        that.$store.commit('json_taken_listini', response);

        try {
          that.changeUrl();
        } catch (error) {
          this.err = error;
        }
        //   doSomethingElse()
      })

  }

  get_json_product_prod(prodk, that, self) {

    this.GET_LIST_PROMISE(prodk, that, self)
      .then((response) => {
        that.data = response.data;
        that.data.details_old = that.data.details;
        that.vetroselected();
        that.finituraselected();
        try {
          if (typeof response.data !== 'undefined') {
            if (typeof response.data.sorgenti_estese !== 'undefined') {
              if (typeof response.data.sorgenti_estese.elettrificazioni[0] !== 'undefined') {
                if (typeof response.data.sorgenti_estese.elettrificazioni[0].Codice !== 'undefined') {
                  that.ledselected(response.data.sorgenti_estese.elettrificazioni[0].Codice, response.data.sorgenti_estese.elettrificazioni);
                }
              }
            }
          }
        } catch (error) {
          that.err = error;
        }
        try {
          that.add_sorgenti(response.data.sorgenti_estese_ul, response.data.sorgenti_estese);
        } catch (error) {
          that.err = error;
        }
        try {
          that.filter_modelli(that.data.details_old);
        } catch (error) {
          that.err = error;
        }
        try {
          that.add_prezzi(response.data.prezzi);
        } catch (error) {
          that.err = error;
        }

        try {
          that.changeUrl();
        } catch (error) {
          that.err = error;
        }

      })
      .catch(function (error) {
        that.data = error;
      });


  }
  async get_image_ricambio(cu) {

   return await this.GET_IMG_RICAMBIO_PROMISE(cu)
      .then((response) => {
        this.response = response;
      
      })
  }
  GET_LIST_PROMISE(PRODK) {

    return new Promise((resolve, reject) => {
      let d = window.descrizione.site_url;
      let url = d + `/famiglie_tipologia/${PRODK}.json`;
      Axios.get(url)
        .then(function ({ data }) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  GET_NOTE_PROMISE() {

    return new Promise((resolve, reject) => {
      let url = '';
      let t = new class_check_language();
      if (t.is_italian()){
         url = 'https://vistosi.it/' + `json/dboTBL_LISTINI_NEW.json`;
      }else{
         url = 'https://vistosi.it/' + `json/dboTBL_LISTINI_DESCR_ESTERE.json`;
        
      }
      Axios.get(url)
        .then(function ({ data }) {
          resolve(data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  select_url(hostname) {
    let url = "https://" + hostname + "/wp-admin/admin-ajax.php";
    if (hostname.includes('localhost')) {
      url = "http://localhost/vistosiwoocommerce/wp-admin/admin-ajax.php";
    }
    return url;
  }
  GET_IMG_RICAMBIO_PROMISE(CU, cl) {
    return new Promise((resolve, reject) => {
      const hostname = window.location.hostname;
      let url = this.select_url(hostname);
      const site = url;
      let params = new URLSearchParams();
      params.append('action', 'get_img_ricambio');
      params.append("product_id", CU);
      params.append("codice_listino", cl);
      Axios.post(site, params
      ).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error)
      })

    }
    );
  }
  async getcodalt_async(store) {
    return await this.GETCODALT(store)
       .then((response) => {
         this.response = response;
       })
   }
  GETCODALT(store) {
    return new Promise((resolve, reject) => {
      const hostname = window.location.hostname;
      let url = this.select_url(hostname);
      const site = url;
      let params = new URLSearchParams();
      try {
        if (store.codalt_hystory.length > 0) {
          let t =  store.codalt_hystory.filter(
              ( codice  ) => {
               return codice.Codice_interno == store.product_store.CODICE_UNIVOCO;
              }
            );
            try {
              if (t.length > 0) {
                resolve(t[0]);
              }
            } catch (error) {
              this.err = error;
            }
          }
        } catch (error) {
          this.err = error;
      }
      params.append("action", "getcodalt");
      params.append("Va", "getcodalt");
      params.append("ID", store.product_store.CODICE_UNIVOCO);
      Axios.post(site, params
      ).then(function (response) {
        try {
          store.codalt_hystory.push(response.data);          
        } catch (error) {
          this.error = error;
        }
        resolve(response);
      }).catch(function (error) {
        reject(error)
      })
   }
    );
  }
  getCodAlt(store) {
    let that = store;
    let params = new URLSearchParams();
    let ur = new is_localhost();
    let url = ur.return_url_website();
    try {
      console.info('GETCODALT',store.codalt_hystory);
      console.info('GETCODALT',store.codalt_hystory.length);
      if (store.codalt_hystory.length > 0) {
        let t =  store.codalt_hystory.filter(
            ( codice  ) => {
              return codice.Codice_interno == store.product_store.CODICE_UNIVOCO;
            }
          );
          if (t.length > 0) {
            that.codalt = t[0].Codice_alternativo_att;
          }
      }
    } catch (error) {
      this.error = error;
    }
    params.append("action", "getcodalt");
    params.append("VB", "getcodalt");
    params.append("ID", store.product_store.CODICE_UNIVOCO);
    Axios.post(url + "wp-admin/admin-ajax.php", params)
      .then(function (response) {
        try {
          that.codalt = response.data.Codice_alternativo_att;
        } catch (error) {
          this.error = error;
        }
      })
      .catch(function (error) {
        this.error = error;
      });
  }
}